define("shared/components/shared/social-identity/placeholder-item", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component"], function (_exports, _component, _templateFactory, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div ...attributes class="cSS--set__item {{if @selectable "cSS--set__item--dashed"}}">
    <div class="o--user cSS--user"
      {{on "click" (fn (optional @toggleSelect) @properties)}} data-test-id="social profile placeholder">
      <span
        class="o--user__avatar cSS--user__avatar--empty cSS--user__avatar--{{@platform}}
          {{if @selectable "is--selectable"}}"
        data-test-id="placeholder avatar">
      </span>
  
      {{#if @selectable}}
        <span class="cSS--user__action">
          {{svg-jar "add" class="o--icon--sm o--icon--white cSS--user__actionIcon"}}
        </span>
      {{/if}}
    </div>
  </div>
  
  
  */
  {
    "id": "BmZ9wOL9",
    "block": "[[[11,0],[17,1],[16,0,[29,[\"cSS--set__item \",[52,[30,2],\"cSS--set__item--dashed\"]]]],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--user cSS--user\"],[24,\"data-test-id\",\"social profile placeholder\"],[4,[38,1],[\"click\",[28,[37,2],[[28,[37,3],[[30,3]],null],[30,4]],null]],null],[12],[1,\"\\n    \"],[10,1],[15,0,[29,[\"o--user__avatar cSS--user__avatar--empty cSS--user__avatar--\",[30,5],\"\\n        \",[52,[30,2],\"is--selectable\"]]]],[14,\"data-test-id\",\"placeholder avatar\"],[12],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"      \"],[10,1],[14,0,\"cSS--user__action\"],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"add\"],[[\"class\"],[\"o--icon--sm o--icon--white cSS--user__actionIcon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"]],[\"&attrs\",\"@selectable\",\"@toggleSelect\",\"@properties\",\"@platform\"],false,[\"if\",\"on\",\"fn\",\"optional\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/social-identity/placeholder-item.hbs",
    "isStrictMode": false
  });

  /**
   * @class PlaceholderItem
   *
   * @extends Component
   *
   * This component provides the logic and templates for the placeholder icons that are used
   * within social sets.
   *
   * Required Arguments:
   * - platform (String) The platform type (FB, IG, TW, PIN, TK, LI) that gets used to render the correct styling.
   * - properties (Hash) A hash of the social identity/set and platform
   *
   * Optional Arguments:
   * - selectable (Boolean) Adds CSS class around placeholder to highlight that it's a selectable target.
   * - toggleSelect (Function) Function that gets called when you click on the placeholder.
   *
   * Examples:
   *
   * Inline Usage with all options:
   * ```
   *  <Shared::SocialIdentity::PlaceholderItem
   *    @platform={{socialProfile.profileType}}
   *    @selectable={{true}}
   *    @toggleSelect={{@toggleSelect}}
   *    @properties={{hash socialIdentity=@socialIdentity platform=socialProfile.profileType}}
   *  />
   * ```
   */
  class PlaceholderItemComponent extends _component2.default {
    get platformAbbreviation() {
      if (this.args.platform === 'ig') {
        return 'ig';
      } else if (this.args.platform === 'tw') {
        return 'tw';
      } else if (this.args.platform === 'pin') {
        return 'pin';
      } else if (this.args.platform === 'fb') {
        return 'fb';
      } else if (this.args.platform === 'li') {
        return 'li';
      } else if (this.args.platform === 'tk') {
        return 'tk';
      }

      return null;
    }

  }

  _exports.default = PlaceholderItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlaceholderItemComponent);
});